import { cn } from "../lib/cn";

/**
 * ThriveScoreReadoutSkeleton, matches the live readout's geometry
 * (gauge on the left, heading + caption + chip on the right).
 *
 * We intentionally do NOT hide the ring outline, a dashboard skeleton for
 * a health score panics users if the numeric region vanishes. The ring
 * renders in its final dimensions, with the number replaced by a small
 * pulse bar; when real data arrives the ring animates up.
 */
export function ThriveScoreReadoutSkeleton({ className }: { className?: string }) {
  return (
    <article
      aria-hidden="true"
      className={cn(
        "group relative flex h-full flex-col rounded-xl border border-border-secondary/70 bg-surface-elevated p-5 shadow-card",
        "skeleton-sheen",
        className,
      )}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="h-[11px] w-[110px] rounded-full bg-gray-200" />
        <div className="h-[22px] w-[46px] rounded-full bg-gray-200" />
      </div>
      <div className="mt-4 flex items-center gap-5">
        <div
          className="relative flex h-[112px] w-[112px] items-center justify-center"
          aria-hidden="true"
        >
          <svg width={112} height={112}>
            <title>Thrive score loading</title>
            <circle cx={56} cy={56} r={51} stroke="var(--color-mist)" strokeWidth={5} fill="none" />
          </svg>
          <div className="absolute h-[22px] w-[44px] rounded-md bg-gray-200" />
        </div>
        <div className="min-w-0 flex-1 space-y-2">
          <div className="space-y-1.5">
            <div className="h-[14px] w-[70%] rounded-full bg-gray-200" />
            <div className="h-[12px] w-[85%] rounded-full bg-gray-200" />
          </div>
          <div className="h-[22px] w-[150px] rounded-full bg-gray-200" />
        </div>
      </div>
    </article>
  );
}
